export default __webpack_public_path__ + "static/media/Group 15528.e328b1e5.svg";